import { Emitter, Event } from "../../../../features/event-emitter"
import { useRoadmapService } from "../../../logistics"

export const useActions = () => {
    const { prepareTruck } = useRoadmapService()

    const submitRoadmap = async (roadmapId: string) => {
        Emitter.emit(Event.DB_SUBMIT)

        await prepareTruck(roadmapId)
        
        Emitter.emit(Event.DB_SUBMIT_DONE, false)
    }

    return {
        submitRoadmap
    }
}
